import React, { cloneElement, useContext, useEffect, useState } from 'react'
import { ClockContext } from 'contexts/TimerAppContexts/ClockContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoon } from '@fortawesome/free-solid-svg-icons'
import { faSun } from '@fortawesome/free-regular-svg-icons'
const PomodoroBalls = () => {
    const {
        breakMode,
        totalPomodoros,
        pomodoroState,
        disableBtn
    } = useContext(ClockContext);

    const elements = []

    for (let i = 0; i < totalPomodoros * 2; i++) {
        if (i % 2 === 0) {
            elements.push(
                <div key={i} className={`ball ${breakMode ? 'break-mode' : ''}`}>
                    <FontAwesomeIcon icon={faSun} />
                </div>
            )
        } else {
            elements.push(
                <div key={i} className={`ball ${breakMode ? 'break-mode' : ''}`}>
                    <FontAwesomeIcon icon={faMoon} />
                </div>
            )
        }
    }

    const [ballsArray, setBallsArray] = useState(elements);
    const [ballIndexSelection, setBallIndexSelection] = useState(0);


    useEffect(() => {
        if (pomodoroState === "Long Break") {
            return
        }
        if (ballIndexSelection !== 0) {
            if (disableBtn === true) {
                const newElements = [...ballsArray]
                newElements[ballIndexSelection - 1] = cloneElement(newElements[ballIndexSelection - 1], {
                    className: `ball completed`,
                })
                setBallsArray(newElements)
                return
            }
            const newElements = [...ballsArray]
            newElements[ballIndexSelection - 1] = cloneElement(newElements[ballIndexSelection - 1], {
                className: `${newElements[ballIndexSelection].props.className}completed`,
            })
            newElements[ballIndexSelection] = cloneElement(newElements[ballIndexSelection], {
                className: `${newElements[ballIndexSelection].props.className}selection`,
            })
            setBallsArray(newElements)
            setBallIndexSelection(preVal => preVal + 1)
        } else {
            const newElements = [...ballsArray]
            newElements[ballIndexSelection] = cloneElement(newElements[ballIndexSelection], {
                className: `${newElements[ballIndexSelection].props.className}selection`,
            })
            setBallsArray(newElements)
            setBallIndexSelection(preVal => preVal + 1)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pomodoroState, disableBtn])

    return (
        <div className='pomodoro-balls'>
            {ballsArray}
        </div>
    )
}

export default PomodoroBalls